'use client'
import React from 'react'
import Header from '@/components/layout/main/header'
import Footer from '@/components/layout/main/footer/Footer'

export default function Layouts({ children }) {
  return (
    <>
      <Header />
      {children}
      <Footer />
    </>
  )
}
